export const PAPERWORK_QUERY_PARAMS = {
  AUTH_TOKEN: 'auth_token',
};



// WEBPACK FOOTER //
// ./src/components/Paperwork/helpers/queryParams.js